export default __webpack_public_path__ + "static/13-2--0857e753b46d9def979c2efee29aabb3.png";